export const urls = {
  bulkCarePlans: () => `/api/client/v1/care-plans/patient-cares/bulk/`,
};

export const keys = {
  all: () => ["care-plans"],
  carePlans: () => [...keys.all(), "care-plans"],
};
